import { render, staticRenderFns } from "./LoginOne.vue?vue&type=template&id=5225b4e6&"
import script from "./LoginOne.vue?vue&type=script&lang=js&"
export * from "./LoginOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LoginOne.vue"
export default component.exports